import {documentContainer} from '@wallaby-ui/document';
import * as React from 'react';
import {TabPanel} from 'react-tabs';

import stylesLayout from './AppLayout.less';

const DocumentPropertiesTabPanel = {
  renderTabPanel(key, props) {
    const {config} = props;
    return (
      <TabPanel
        className={{
          'react-tabs__tab-panel': true,
          [stylesLayout.dlTabColumn]: true,
        }}
        key={key}
      >
        <documentContainer.DocumentFileAttributesContainer
          documentStateId={documentContainer.DOCUMENT_REDUCER_STATE_ID}
          config={config}
          loadingDisabled
          showOpenDocumentButton={false}
        />
      </TabPanel>
    );
  },
};

DocumentPropertiesTabPanel.displayName = 'DocumentPropertiesTabPanel';

export default DocumentPropertiesTabPanel;
